import { render, staticRenderFns } from "./ContractTemplate.vue?vue&type=template&id=8b7ac532&"
import script from "./ContractTemplate.vue?vue&type=script&lang=js&"
export * from "./ContractTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports